<template>
  <div style="background: #f5f5f5;">
    <HeaderView :title="$t('infomation.setname')" 
    :right="$t('common.save')"
    :rightclick="'tosave'"
    @tosave="save()" />
    <div class="view-page">
      <van-cell-group>
        <van-field
          v-model="name"
          :label="$t('infomation.name')"
          :placeholder="$t('infomation.name_place')"
        />
      </van-cell-group>
      <p style="margin: 10px auto;width: 80%;font-size: 14px;">{{$t("infomation.name_tip")}}</p>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "SetNameView",
  components: { HeaderView },
  data() {
    return {
      name:"",
      userInfo:{}
    };
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/login'})
    }else {
      this.getUserInfo();
    }
  },
  methods: {
    save(){
      if(this.userInfo.name){
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{name:this.name},
        url: 'user_set_name'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
};
</script>

<style></style>
